export const version = "hash/5.2.0";
